// Make sure the JSON script is rendered on the page before the scripts are.
var pageInfoScript = document.getElementById('page_info');
export var pageInfo = pageInfoScript ? JSON.parse(pageInfoScript.textContent): {};
